export const Text = {
  variants: {
    'textMuted': {
      color: 'gray.600',
    },
  },
}
